













import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<ActionIcon>({
  //
})
export default class ActionIcon extends Vue {
  @Prop({ default: 'mdi-plus-circle' }) protected icon!: string;

  @Prop({ default: '' }) protected iconClass!: string;

  @Prop({ default: '' }) protected tooltip!: string;

  @Prop({ default: '' }) protected hoverColor!: string;

  @Prop({ default: 500 }) protected hoverColorIntensity!: number;

  public mounted(): void {
    //
  }

  protected onClick(): void {
    this.$emit('onClick');
  }

  protected get hasTooltip(): boolean {
    return !! this.tooltip.length;
  }
}
